import type { CSSObject } from "type/tss";

export const styles = () => {
	return ({
		root: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
		},
	} satisfies Record<string, CSSObject>);
};
